import { Col, Row, Typography } from "antd";
import CompanyEmployeesView from "../components/CompanyEmployeesView";

function CompanyEmployeesPage() {
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Employees
        </Typography.Title>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <CompanyEmployeesView />
      </Col>
    </Col>
  );
}

export default CompanyEmployeesPage;
